import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';

// Mirrors iOS AuthenticationView — sign in / sign up with 7-day trial
const AuthView: React.FC = () => {
  const { signIn, signUp, continueAsGuest } = useAuth();
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [fullName, setFullName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isValid = isSignUp
    ? email.length > 0 && password.length >= 6 && password === confirmPassword && displayName.length > 0
    : email.length > 0 && password.length > 0;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValid || isSubmitting) return;

    setIsSubmitting(true);
    setError(null);
    try {
      if (isSignUp) {
        await signUp(email, password, displayName, fullName || undefined);
      } else {
        await signIn(email, password);
      }
    } catch (err: any) {
      setError(err?.message ?? 'Authentication failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '12px 14px',
    marginBottom: '12px',
    border: '1px solid #ddd',
    borderRadius: '10px',
    fontSize: '15px',
    boxSizing: 'border-box'
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f7fa',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '32px',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.1)'
      }}>
        <img
          src={logo}
          alt="2EZ"
          style={{ display: 'block', width: '110px', margin: '0 auto 12px', borderRadius: '24px' }}
        />
        <p style={{ margin: '0 0 24px', color: '#666', textAlign: 'center', fontSize: '14px' }}>
          Community-driven map for St. Kitts & Nevis
        </p>

        <form onSubmit={handleSubmit}>
          {isSignUp && (
            <>
              <input
                style={inputStyle}
                type="text"
                placeholder="Display name"
                value={displayName}
                onChange={e => setDisplayName(e.target.value)}
                autoComplete="nickname"
              />
              <input
                style={inputStyle}
                type="text"
                placeholder="Full name (optional)"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
                autoComplete="name"
              />
            </>
          )}

          <input
            style={inputStyle}
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoComplete="email"
          />
          <input
            style={inputStyle}
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete={isSignUp ? 'new-password' : 'current-password'}
          />
          {isSignUp && (
            <input
              style={inputStyle}
              type="password"
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
            />
          )}

          {isSignUp && password.length > 0 && password.length < 6 && (
            <p style={{ color: '#ff3b30', fontSize: '13px', margin: '0 0 8px' }}>
              Password must be at least 6 characters
            </p>
          )}
          {isSignUp && confirmPassword.length > 0 && password !== confirmPassword && (
            <p style={{ color: '#ff3b30', fontSize: '13px', margin: '0 0 8px' }}>
              Passwords do not match
            </p>
          )}
          {error && (
            <p style={{ color: '#ff3b30', fontSize: '13px', margin: '0 0 12px' }}>{error}</p>
          )}

          <button
            type="submit"
            disabled={!isValid || isSubmitting}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: isValid ? '#007aff' : '#ccc',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '16px',
              fontWeight: 600,
              cursor: isValid ? 'pointer' : 'not-allowed'
            }}
          >
            {isSubmitting ? 'Please wait…' : isSignUp ? 'Create Account' : 'Sign In'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '14px', color: '#666' }}>
          {isSignUp ? 'Already have an account?' : "Don't have an account?"}{' '}
          <button
            onClick={() => { setIsSignUp(!isSignUp); setError(null); }}
            style={{ background: 'none', border: 'none', color: '#007aff', cursor: 'pointer', fontSize: '14px', fontWeight: 600 }}
          >
            {isSignUp ? 'Sign In' : 'Sign Up — 7 day free trial'}
          </button>
        </p>

        <button
          onClick={continueAsGuest}
          style={{
            width: '100%', padding: '12px', marginTop: '8px',
            backgroundColor: 'transparent', color: '#666',
            border: '1px solid #ddd', borderRadius: '10px',
            fontSize: '15px', fontWeight: 600, cursor: 'pointer'
          }}
        >
          Continue as Guest
        </button>
      </div>
    </div>
  );
};

export default AuthView;
